<div class="px-px-24 py-px-1" style="background: #F3F8FA;">
  <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; margin-top: 1rem;">
    <h1 style="margin: 0;">Gestion des établissements</h1>
    <div style="margin-left: auto;">
      <app-button
        text="Ajouter un établissement"
        srcIcon="assets/icons/plus.svg"
        (handleClick)="openAddEtablissementDialog()"
      ></app-button>
    </div>
  </div>

  <div class="inner-add-on left-add-on my-3">
    <input type="search" class="form-control"
           (input)="searchItem($event)"
           placeholder="Rechercher un établissement" />
    <svg-icon class="inner-icon left" svgClass="placeholder-icon" src="/assets/icons/search-grey.svg"></svg-icon>
  </div>

  <app-data-table
    [isLoading]="isLoading"
    [dataSource]="etabListFiltered"
    [columns]="customColumns"
    (onFullRowClick)="handleRowClick($event)"
    [hasRowAction]="true"
    [showSideBar]="true"
    [totalItems]="totalItems"
    (nextPage)="pagination($event)"
    [pageSize]="size"
    [pageIndex]="offset"
  ></app-data-table>
</div>
